<div class="concept-list-selector admin-scroll-layout">
  <div class="admin-content-top concept-list-selector__list-title">
    <h5>
      {{ 'TRANS__SEARCH_VIEWS__CONCEPT_HOME' | translate}}
    </h5>
  </div>
  <div class="concept-table">
    @if (conceptTypeMainMenus.data.length && currentConceptTypeMenu) {
      <ng-container>
        <table
          mat-table
          [dataSource]="conceptTypeMainMenus"
        >
          <ng-container matColumnDef="letter">
            <td
              mat-cell
              *matCellDef="let conceptTypeMainMenu"
              class="concept-table__letter text-primary"
            >
              <span>
                {{conceptTypeMainMenu['letter']}}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="list">
            <td
              mat-cell
              *matCellDef="let conceptTypeMainMenu"
              class="concept-table__lists"
            >
              @for (subMenu of conceptTypeMainMenu['subMenus']; track $index) {
                <div class="concept-table__list">
                  @if (subMenu) {
                    <div
                      class="concept-table__list-content text-primary-hover"
                      (click)="toggleConcept(subMenu)"
                      (keydown)="null"
                      [ngClass]="{'active': subMenu['menuTitle'] === currentConceptTypeMenu['menuTitle'],
                                  'active-parent': subMenu['menuTitle'] === currentConceptTypeMenu.parentName}"
                    >
                      @if (subMenu['menuTitle'] === currentConceptTypeMenu['menuTitle']) {
                        <div class="concept-table__list-vertical-line"></div>
                      }

                      <div class="concept-table__list-name-content">
                        <span class="concept-table__list-name">
                          {{subMenu['menuTitle'] | translate}}
                        </span>

                        @if (!subMenu['subMenus'].length) {
                          <mat-icon>chevron_right</mat-icon>
                        }
                        @else {
                          @if (!subMenu.open) {
                            <a>
                              <span class="concept-table__list-has-sub-menu toneDownTextColor">
                                <span>{{ 'TRANS__ADMIN_CONCEPT__SHOW_SUB_CATEGORY' | translate }}</span>
                                <span>({{subMenu['subMenus'].length}})</span>
                              </span>
                              <mat-icon>expand_more</mat-icon>
                            </a>
                          }
                          @else {
                            <a>
                              <span class="concept-table__list-has-sub-menu">
                                <span>{{ 'TRANS__ADMIN_CONCEPT__CLOSE_SUB_CATEGORY' | translate }}</span>
                              </span>
                              <mat-icon>close</mat-icon>
                            </a>
                          }
                        }
                      </div>
                    </div>
                  }

                  @if (subMenu.open) {
                    <div class="concept-table__sub-lists">
                      @for (subSubMenu of subMenu['subMenus']; track $index) {
                        <div
                          class="concept-table__sub-list text-blue-hover"
                          [ngClass]="{'active': subSubMenu['menuTitle'] === currentConceptTypeMenu['menuTitle']}"
                          (click)="toggleConcept(subSubMenu)"
                          (keydown)="null"
                        >
                          @if (subSubMenu['menuTitle'] === currentConceptTypeMenu['menuTitle']) {
                            <div class="concept-table__list-vertical-line"></div>
                          }
                          <div class="concept-table__sub-list-content">
                            <span class="concept-table__list-name">
                              {{ subSubMenu['menuTitle'] | translate }}
                            </span>
                            <mat-icon>chevron_right</mat-icon>
                            <hr>
                          </div>

                        </div>
                      }
                    </div>
                  }


                </div>
              }

              @if (!conceptTypeMainMenu['subMenus'].length) {
                <div class="concept-table__no-list">
                  <div class="concept-table__list-name-content">
                    <span class="toneDownTextColor">
                      {{ 'TRANS__ADMIN_CONCEPT__NO_LISTS_IN_CATEGORY' | translate }}
                    </span>
                  </div>
                </div>
              }
            </td>
          </ng-container>
          <tr
            *matRowDef="let element; columns: listColumns;"
            class="concept-rows" mat-row></tr>
        </table>
      </ng-container>
    }
    @else {
      <span class="concept-table__no-concept-type">{{ 'TRANS__ADMIN_CONCEPT__NO_CONCEPT_TYPES' | translate }}</span>
    }
  </div>
</div>
